export default __webpack_public_path__ + "static/About-us-access-dc0c503bccb05e854b6ab242b5393735.png";